export interface IWorkingDay {
    StartsAt: string;
    EndsAt: string;
}

export interface ITeamWorkingHours {
    Monday: IWorkingDay;
    Tuesday: IWorkingDay;
    Wednesday: IWorkingDay;
    Thursday: IWorkingDay;
    Friday: IWorkingDay;
    Saturday: IWorkingDay;
    Sunday: IWorkingDay;
}

export class WorkingDay implements IWorkingDay {
    StartsAt: string = '';
    EndsAt: string = '';
}

export class TeamWorkingHours implements ITeamWorkingHours {
    Monday: IWorkingDay = new WorkingDay();
    Tuesday: IWorkingDay = new WorkingDay();
    Wednesday: IWorkingDay = new WorkingDay();
    Thursday: IWorkingDay = new WorkingDay();
    Friday: IWorkingDay = new WorkingDay();
    Saturday: IWorkingDay = new WorkingDay();
    Sunday: IWorkingDay = new WorkingDay();
}
